import { usePatientPdfDownload } from "features/patients/hooks/usePatientPdfDownload";

/**
 * Every Letter and Other Document of a patient as one PDF (KIN-2207), with a cover page
 * that lists what could not be included rather than failing on it.
 */
export const useDownloadPatientDocuments = () =>
  usePatientPdfDownload({
    suffix: "/documents",
    fallbackFilename: (patientId) => `patient-documents-${patientId}.pdf`,
    failureMessage: "Failed to download letters and documents",
  });
